import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appBlockKeys]',
})
export class BlockKeysDirective {
  @Input() blockedKeys: string[] = [];

  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.blockedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}
